import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { Close } from '@material-ui/icons';

import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';

import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import { useToggleNavBar } from '../../libraries/contexts';

import { TRANSLATIONS } from '../../libraries/texts';
import { snackBar as styles } from './css';

const snackBar = props => {
  const { classes } = props;

  const [open, setOpen] = useState(false);
  const [messageInfo, setMessageInfo] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [snackBarTime, setSnackBarTime] = useState(10000);

  const [toggleValue, changeToggleNavBar] = useToggleNavBar();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setMessageInfo({ key: '' });
  }, []);

  useEffect(() => {
    const { message } = toggleValue;

    if (message && message.open) {
      setMessageInfo(message);
      setOpen(true);
    }
  }, [toggleValue.message]);

  const handleExited = () => {};

  const handleUndo = async () => {
    const { service, key } = toggleValue.message;
    try {
      await service.undo(key);
      const { main, secondary, message } = toggleValue;
      changeToggleNavBar({
        main,
        secondary,
        message: { message: message.message, undo: true, key, service, open: false }
      });
      setOpen(false);
    } catch (err) {
      const {
        response: { data }
      } = await err;
      const { errors } = data;
      if (errors) {
        const messages = errors.map(elem => (!TRANSLATIONS[elem] ? '' : TRANSLATIONS[elem]));
        setSnackBarTime(20000);
        setErrorMessages(messages);
      }
    }
  };

  return (
    <React.Fragment>
      <Snackbar
        key={messageInfo.key}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={open}
        autoHideDuration={snackBarTime}
        onClose={handleClose}
        onExited={handleExited}
        ContentProps={{
          'aria-describedby': 'message-id'
        }}
        message={
          <span id="message-id">
            {errorMessages.length > 0 ? errorMessages.join(',') : messageInfo.message}
          </span>
        }
        action={[
          errorMessages.length > 0 ? (
            ''
          ) : (
            <Button
              key={`${messageInfo.key}-undo`}
              color="secondary"
              size="small"
              onClick={handleUndo}
            >
              DESHACER
            </Button>
          ),
          <Tooltip key={`${messageInfo.key}-tooltip`} title="Cerrar" placement="top">
            <IconButton
              key={`${messageInfo.key}-close`}
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={handleClose}
            >
              <Close />
            </IconButton>
          </Tooltip>
        ]}
      />
    </React.Fragment>
  );
};

snackBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(snackBar);
